import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import user from './modules/user'
import permission from './modules/permission'
import socket from './modules/socket'
import getters from './getters'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    user,
    permission,
    socket
  },
  state: {
    commonData: {
      isReLogin: false
    },
  },
  mutations: {
    setReLogin(state, val){
      state.commonData.isReLogin = val;
    },
    setHeadImg(state, val) {
      state.user.info.avatar = val
      // state.commonData.isReLogin = val;
    },
    setUserPhone(state, val) {
      state.user.info.phone = val
      // state.commonData.isReLogin = val;
    }
  },
  actions: {
  },
  getters: {
    ...getters
  }
})